module.exports = __webpack_public_path__ + "img/2108.ddb19956.jpg";